/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_A3dInputs */

const en_mk_sol_operasional_a3d = /** @type {(inputs: Mk_Sol_Operasional_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handles reminders and outside follow-ups, always through an approval.`)
};

const id_mk_sol_operasional_a3d = /** @type {(inputs: Mk_Sol_Operasional_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengurus pengingat dan tindak lanjut ke pihak luar, selalu lewat approval.`)
};

/**
* | output |
* | --- |
* | "Handles reminders and outside follow-ups, always through an approval." |
*
* @param {Mk_Sol_Operasional_A3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_a3d = /** @type {((inputs?: Mk_Sol_Operasional_A3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_A3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_a3d(inputs)
	return en_mk_sol_operasional_a3d(inputs)
});